(function () {
  var stickyBar = document.getElementById('StickyAddToCart');
  if (!stickyBar) return;

  // Move sticky bar to body so it escapes any section stacking context
  document.body.appendChild(stickyBar);

  // ──── Detect page type ────
  // v24 pages have #app-2 with Vue-driven buy box
  // product-section pages have variant-picker-vue with [data-atc-wrapper]
  // generic product pages have neither — we locate the add-to-cart form instead
  var isV24 = !!document.getElementById('app-2');
  var variantPicker = document.querySelector('variant-picker-vue');

  // Bundle-builder pages (Fasting Bar PDP, snippets/prolon-bundle-builder.liquid)
  // have no form and no button[name="add"] — the buy box is a flavor picker with
  // per-flavor quantities and a single [data-bpb-cta] that posts to /cart/add.js.
  // Without this branch findGenericTarget() returns null and the whole bar bails.
  // .bpb-portal is the progress bar this component pins under the header; it
  // carries the same data-bpb attribute, so it has to be excluded here.
  var bpbRoot = document.querySelector('[data-bpb]:not(.bpb-portal)');
  var bpbCta = bpbRoot ? bpbRoot.querySelector('[data-bpb-cta]') : null;

  // Gate for the A/B test: the bar is built and kept in sync on this page, but
  // snippets/sticky-add-to-cart.liquid hides it behind this class so the test
  // tool owns the reveal. Control renders exactly as it does today.
  if (bpbRoot) document.body.classList.add('dk-sticky-bpb');

  // Generic product pages: no #app-2, no variant-picker-vue.
  // Find the real add-to-cart form so the observer has something to watch.
  function findGenericTarget() {
    var scope = document.getElementById('ck-product-form') || document;
    var btn = scope.querySelector('button[name="add"]');
    return (
      scope.querySelector('[data-atc-wrapper]') ||
      scope.querySelector('product-form') ||
      scope.querySelector('form[action*="/cart/add"]') ||
      (btn ? btn.parentElement : null)
    );
  }

  var genericTarget = findGenericTarget();

  // Determine the scroll target — where to scroll when sticky is clicked
  var scrollTarget =
    bpbRoot ||
    document.querySelector('[data-atc-wrapper]') ||
    document.getElementById('app-2') ||
    genericTarget ||
    document.getElementById('product-section') ||
    document.getElementById('ck-product-form') ||
    variantPicker;

  // Determine what element to observe for show/hide
  var observeTarget =
    bpbRoot ||
    document.querySelector('[data-atc-wrapper]') ||
    document.getElementById('app-2') ||
    genericTarget;

  if (!observeTarget) return;

  // ──── Button click ────
  // SYNC MODE ON  → add the currently selected variant to cart, then let the
  //                 existing cart drawer / upsell flow take over (same as the
  //                 buy box button, because it calls the same method).
  // SYNC MODE OFF → original behaviour: scroll to the buy box.
  // GENERIC PAGES → always scroll to the buy box (no Vue instance exists).
  var allButtons = stickyBar.querySelectorAll('button');

  function scrollToBuyBox() {
    if (!scrollTarget) return;
    var headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-group-height') || '120',
      10
    );
    var targetRect = scrollTarget.getBoundingClientRect();
    var scrollTo = window.pageYOffset + targetRect.top - headerHeight - 20;
    window.scrollTo({ top: scrollTo, behavior: 'smooth' });
  }

  // Find the page's real add-to-cart control (generic pages)
  function findRealAtcButton() {
    var scope =
      document.getElementById('ck-product-form') ||
      document.getElementById('app-2') ||
      document;

    var direct =
      scope.querySelector('product-form button[name="add"]') ||
      scope.querySelector('form[action*="/cart/add"] button[name="add"]') ||
      scope.querySelector('button[name="add"]') ||
      scope.querySelector('[data-atc-wrapper] button');

    if (direct) return direct;

    // Fallback: match on button text (covers Vue buy boxes with no form)
    var candidates = scope.querySelectorAll('button, [role="button"]');
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c.closest('#StickyAddToCart')) continue; // never click ourselves
      if (c.disabled) continue;
      if (c.offsetParent === null) continue; // hidden / in a closed modal
      if (!/add\s*to\s*(cart|bag)/i.test(c.textContent || '')) continue;
      return c;
    }

    return null;
  }

  // ──── Busy state (mirrors the buy box "Adding..." behaviour) ────
  var busyTimer = null;

  function setStickyBusy(on) {
    allButtons.forEach(function (btn) {
      if (!btn.dataset.dkOriginalText) {
        btn.dataset.dkOriginalText = btn.textContent.trim() || 'ADD TO CART';
      }
      btn.textContent = on ? 'ADDING...' : btn.dataset.dkOriginalText;
      btn.disabled = on;
      btn.style.opacity = on ? '0.7' : '';
      btn.style.cursor = on ? 'wait' : 'pointer';
    });

    clearTimeout(busyTimer);
    if (on) {
      // Safety net: never leave the button stuck if no cart event fires
      busyTimer = setTimeout(function () { setStickyBusy(false); }, 8000);
    }
  }

  // Clear busy as soon as the theme signals the cart changed / drawer opened
  ['cart:refresh', 'cart:updated', 'cart:build', 'cart:open', 'cart:change'].forEach(
    function (evt) {
      document.documentElement.addEventListener(evt, function () { setStickyBusy(false); });
      document.addEventListener(evt, function () { setStickyBusy(false); });
    }
  );

  function genericAddToCart() {
    var realBtn = findRealAtcButton();

    if (realBtn && !realBtn.disabled) {
      realBtn.click(); // theme handles fetch + cart drawer + analytics
      return true;
    }

    // No button, but a form exists — let the theme's submit handler run
    var scope = document.getElementById('ck-product-form') || document;
    var form = scope.querySelector('form[action*="/cart/add"]');
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
      return true;
    }

    return false;
  }

  allButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      if (btn.disabled) return;

      // 1. Bundle builder (Fasting Bar) — hand the click to its own CTA so the
      //    exact selected flavors, quantities and purchase type are what gets
      //    posted, and its cart-drawer + discount flow runs unchanged. While the
      //    CTA is disabled nothing is selected yet, so send the shopper up to the
      //    buy box instead of adding an unconfigured item.
      if (bpbCta) {
        if (bpbCta.disabled) {
          scrollToBuyBox();
          return;
        }
        setStickyBusy(true);
        bpbCta.click();
        return;
      }

      var vm = window.__dkProductVM;
      var canSync =
        vm &&
        typeof vm.addToCart === 'function' &&
        vm.selected_variant &&
        vm.selected_variant.id;

      // 2. dk-product (ProLon) — Vue handles its own button state
      if (canSync) {
        if (vm.addingtoCart) return; // already in flight
        try {
          vm.addToCart(vm.selected_variant);
        } catch (err) {
          console.error('[sticky-atc] addToCart failed, falling back to scroll:', err);
          scrollToBuyBox();
        }
        return;
      }

      // 3. Every other product — trigger the page's own add to cart
      setStickyBusy(true);
      if (genericAddToCart()) return;

      // 4. Nothing addable found — old behaviour
      setStickyBusy(false);
      scrollToBuyBox();
    });
  });

  // ──── Sticky bar elements ────
  var labelEl = document.getElementById('sticky-atc-label');
  var freqEl = document.getElementById('sticky-atc-freq');
  var variantEl = document.getElementById('sticky-atc-variant');
  var priceEl = document.getElementById('sticky-atc-price');
  var comparePriceEl = document.getElementById('sticky-atc-compare-price');
  var badgeEl = document.getElementById('sticky-atc-badge');
  var footnoteEl = document.getElementById('sticky-atc-footnote');

  // Mobile bar elements
  var mobileBar = stickyBar.querySelector('.sticky-atc-mobile');
  var mTitleEl = document.getElementById('sticky-atc-m-title');
  var mOptionEl = document.getElementById('sticky-atc-m-option');
  var mPriceEl = document.getElementById('sticky-atc-m-price');
  var mCompareEl = document.getElementById('sticky-atc-m-compare');

  // Product title passed down from Liquid — used on generic pages
  var GENERIC_TITLE = stickyBar.getAttribute('data-product-title') || '';

  // ──── Flavor display names (match the buy box) ────
  var FLAVOR_LABELS = {
    'Original': 'Original',
    'Gen3': 'Bold Flavors',
    'Expanded Variety': 'Expanded Variety',
    'Next Gen': 'Next Gen'
  };

  function flavorLabel(value) {
    if (!value) return '';
    return FLAVOR_LABELS[value] || value;
  }

  // ──── Shared painter ────
  function setNode(el, val, displayWhenOn) {
    if (!el) return;
    el.textContent = val || '';
    el.style.display = val ? (displayWhenOn || '') : 'none';
  }

  // Offer labels in the buy box can nest a savings badge inside the very
  // element that holds the name (dk-product-reset-horizon-v4 puts
  // .dk-save-badge inside .name-value), so a plain textContent read returns
  // "Subscribe & SaveSave $7.50 (15% off)". Drop the known badge nodes, then
  // strip a trailing "Save $x (y% off)" as a safety net for sections that
  // append the same wording without those classes.
  var LABEL_NOISE = '.dk-save-badge, .dk-offer-compare, .dk-offer-price';
  var TRAILING_SAVINGS = /\s*save\s+\$[\d.,]+\s*(?:\([^)]*\))?\s*$/i;

  function cleanLabel(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    [].slice.call(clone.querySelectorAll(LABEL_NOISE)).forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    return clone.textContent
      .replace(/\s+/g, ' ')
      .replace(TRAILING_SAVINGS, '')
      .trim();
  }

  // Subtitle painter — "<flavor> / <purchase option>". The flavor name is the
  // long, least decision-critical half, so it is the part that ellipsises; the
  // purchase option is what the shopper is actually choosing and stays whole.
  function setOptionLine(el, flavor, plan) {
    if (!el) return;

    // updateStickyInfo() runs on a poll, so skip the rebuild when nothing moved.
    var key = (flavor || '') + '\u0000' + (plan || '');
    if (el.dataset.dkOptionKey === key) return;
    el.dataset.dkOptionKey = key;

    el.textContent = '';
    if (!flavor && !plan) {
      el.style.display = 'none';
      return;
    }
    el.style.display = 'flex';

    if (flavor) {
      var f = document.createElement('span');
      f.className = 'sticky-atc-opt-flavor';
      f.textContent = flavor;
      f.title = flavor; // full name still reachable when truncated
      el.appendChild(f);
    }
    if (flavor && plan) {
      var sep = document.createElement('span');
      sep.className = 'sticky-atc-opt-sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '/';
      el.appendChild(sep);
    }
    if (plan) {
      var p = document.createElement('span');
      p.className = 'sticky-atc-opt-plan';
      p.textContent = plan;
      el.appendChild(p);
    }
  }

  // One painter for every page type. price/compare are display strings.
  function paintSticky(o) {
    var suffix = o.isSub ? '/mo' : '';

    // Desktop
    setNode(labelEl, o.title, 'inline');
    setOptionLine(variantEl, o.flavor, o.plan);
    setNode(freqEl, o.freq ? 'every ' + o.freq : '', 'inline-block');
    if (priceEl && o.price) priceEl.textContent = o.price + suffix;

    var nc = String(o.compare || '').replace(/[^0-9.]/g, '');
    var np = String(o.price || '').replace(/[^0-9.]/g, '');
    var showCompare = nc && nc !== np;
    setNode(comparePriceEl, showCompare ? o.compare : '', '');
    setNode(badgeEl, o.badge, 'inline-block');
    if (footnoteEl) footnoteEl.style.display = o.isSub ? '' : 'none';

    // Mobile — always expanded so every product matches
    if (mobileBar) mobileBar.classList.add('dk-expanded');
    setNode(mTitleEl, o.title, 'block');
    setOptionLine(mOptionEl, o.flavor, o.plan);
    if (mPriceEl && o.price) mPriceEl.textContent = o.price + suffix;
    setNode(mCompareEl, showCompare ? o.compare : '', '');
  }

  // ──── Strategy A: generic + variant-picker-vue pages ────
  function readGenericState() {
    var card = null;
    if (variantPicker) {
      var checked = variantPicker.querySelectorAll(
        '.variant-option__radio-card input[type="radio"]:checked'
      );
      if (checked.length) {
        card = checked[checked.length - 1].closest('.variant-option__radio-card');
      }
    }

    var scope = card || document.getElementById('ck-product-form') || document;
    var priceEl2 =
      scope.querySelector('.variant-option__price') ||
      scope.querySelector('[data-price]') ||
      scope.querySelector('.price');
    var compareEl2 =
      scope.querySelector('.variant-option__compare_at_price') ||
      scope.querySelector('.line-through');
    var titleEl2 = card ? card.querySelector('.text-body-bold') : null;

    return {
      title: GENERIC_TITLE,
      flavor: cleanLabel(titleEl2),
      plan: '',
      price: priceEl2 ? priceEl2.textContent.trim() : (mPriceEl ? mPriceEl.textContent.trim() : ''),
      compare: compareEl2 ? compareEl2.textContent.trim() : '',
      badge: '',
      freq: '',
      isSub: !!(card && card.dataset.isSubscription === 'true')
    };
  }

  // ──── Strategy A2: bundle builder (Fasting Bar) ────
  // State is read back out of the buy box rather than off the bpb:change payload
  // so a repaint is correct whenever it runs, including the safety-net poll.
  function bpbQty() {
    var q = 0;
    var cards = bpbRoot.querySelectorAll('[data-bpb-flavor]');
    for (var i = 0; i < cards.length; i++) {
      q += parseInt(cards[i].dataset.qty || '0', 10) || 0;
    }
    return q;
  }

  function bpbFreq() {
    var checked = bpbRoot.querySelector('[data-bpb-opt] input:checked');
    return (checked && checked.value) || 'subscribe';
  }

  // Take the wording off the option card itself so the bar echoes whatever copy
  // the section is configured with instead of a second hardcoded label.
  function bpbPlanLabel(freq) {
    var el = bpbRoot.querySelector('[data-bpb-opt="' + freq + '"] .bpb-opt__left');
    var txt = cleanLabel(el);
    return txt || (freq === 'subscribe' ? 'Subscribe & Save' : 'One-time purchase');
  }

  // The CTA already reads "<prefix> · <bundle total>" and is re-rendered on every
  // selection change, so reading the total back off it is what keeps the bar and
  // the buy box from ever disagreeing — and it needs no money formatter here.
  function bpbTotal() {
    var txt = (bpbCta && bpbCta.textContent) || '';
    var i = txt.indexOf('\u00B7');
    return i === -1 ? '' : txt.slice(i + 1).trim();
  }

  function updateFromBpb() {
    var qty = bpbQty();
    var total = bpbTotal();

    paintSticky({
      title: GENERIC_TITLE,
      flavor: qty ? qty + (qty === 1 ? ' box' : ' boxes') : '',
      plan: qty ? bpbPlanLabel(bpbFreq()) : 'Choose your flavors',
      price: total,
      // No compare price: the buy box strikes through a per-box figure, and there
      // is no bundle-level "was" total it publishes, so anything shown here would
      // be a number the shopper never sees above.
      compare: '',
      badge: '',
      freq: '',
      isSub: false
    });

    // paintSticky leaves the price nodes untouched when there is nothing to
    // paint, which would leave the Liquid-rendered single-variant price standing
    // as if it were the bundle total. Clear it while the selection is empty.
    if (!total) {
      if (priceEl) priceEl.textContent = '';
      if (mPriceEl) mPriceEl.textContent = '';
    }
  }

  // ──── Strategy B1: dk-product v24, SYNC MODE (theme setting ON) ────
  // Reads straight off the Vue instance — no class-name scraping, so it
  // survives buy box redesigns.
  function updateFromVueInstance(vm) {
    var isSubscription = !!(vm.selected_options &&
      String(vm.selected_options.option_2 || '').toLowerCase().indexOf('subscri') !== -1);
    var isSub = vm.sub_type === 'single' && isSubscription;
    var isDouble = vm.sub_type === 'double';

    var flavourText = flavorLabel(vm.selected_options && vm.selected_options.option_1);
    var planText = isSub ? 'Subscribe & Save' : (isDouble ? 'Buy 2 Boxes' : 'One-time purchase');
    var productTitle = (vm.product && vm.product.title)
      ? vm.product.title
      : (GENERIC_TITLE || (labelEl ? labelEl.textContent.trim() : ''));

    var freq = '';
    if (isSub && vm.selected_plan && vm.selected_plan.name) {
      freq = vm.selected_plan.name.replace(/Deliver(y)?\s+every\s+/i, '').trim();
    }

    var badgeSrc = document.querySelector('#app-2 [data-sticky-sale-badge]');

    paintSticky({
      title: productTitle,
      flavor: flavourText,
      plan: planText,
      price: vm.calculatedPrice || '',
      compare: vm.compare_at_price || '',
      badge: badgeSrc ? badgeSrc.textContent.trim() : '',
      freq: freq,
      isSub: isSub
    });

    // ── Button state (mirrors the buy box button while adding) ──
    var busy = !!vm.addingtoCart;
    var soldOut = vm.selected_variant && vm.selected_variant.available === false;

    allButtons.forEach(function (btn) {
      var isMobileBtn = btn.id === 'sticky-atc-button-mobile';

      if (!btn.dataset.dkOriginalText) {
        // Compact button gets a shorter label so it fits beside the info column
        btn.dataset.dkOriginalText = isMobileBtn ? 'ADD TO CART' : btn.textContent.trim();
      }
      if (soldOut) {
        btn.textContent = 'SOLD OUT';
        btn.disabled = true;
        btn.style.opacity = '0.55';
        btn.style.cursor = 'not-allowed';
        return;
      }
      btn.textContent = busy ? 'ADDING...' : btn.dataset.dkOriginalText;
      btn.disabled = busy;
      btn.style.opacity = busy ? '0.7' : '';
      btn.style.cursor = busy ? 'wait' : 'pointer';
    });
  }

  // ──── Strategy B2: dk-product v24, LEGACY MODE (theme setting OFF) ────
  function updateFromV24() {
    var srcPrice = document.querySelector('#app-2 [data-sticky-calculated-price]') ||
      document.querySelector('[data-sticky-calculated-price]');
    var srcCompare = document.querySelector('#app-2 [data-sticky-compare-price]') ||
      document.querySelector('[data-sticky-compare-price]');
    var srcBadge = document.querySelector('#app-2 [data-sticky-sale-badge]') ||
      document.querySelector('[data-sticky-sale-badge]');

    // Detect subscription from selected option cards in #app-2
    var isSubscription = false;
    var allSelected = document.querySelectorAll('#app-2 .border-prolon_green');
    allSelected.forEach(function (el) {
      var nameEl = el.querySelector('.name-value');
      if (nameEl) {
        var txt = nameEl.textContent.toLowerCase();
        if (txt.includes('subscri')) isSubscription = true;
      }
    });

    // ── Selected flavor card ──
    // Selected cards carry `border-2 ... bg-white`; unselected carry plain `border`.
    // Offer cards (Subscribe / One-time / a bundle) use the same pattern, so
    // OFFER_WORDS is what tells the two apart. `\d+x` and `bundle` cover kit
    // options such as "3x Reset Kit Bundle" on the 1-Day Reset PDP.
    var OFFER_WORDS = /subscribe|one[-\s]?time|buy\s*2|\d+x\s|purchase|bundle/i;
    var BADGE_WORDS = /^(bestseller|most popular|new|best value|popular)$/i;

    function cardTitle(card) {
      var leaves = [].slice.call(card.querySelectorAll('*')).filter(function (el) {
        return el.children.length === 0 && el.textContent.trim();
      });
      for (var i = 0; i < leaves.length; i++) {
        var t = leaves[i].textContent.trim();
        if (!BADGE_WORDS.test(t)) return t;
      }
      return '';
    }

    var flavourText = '';
    var selectedCards = document.querySelectorAll('#app-2 .border-2');
    for (var s = 0; s < selectedCards.length; s++) {
      var card = selectedCards[s];
      if (card.className.indexOf('bg-white') === -1) continue;
      if (OFFER_WORDS.test(card.textContent)) continue; // that's the offer card
      flavourText = cardTitle(card);
      if (flavourText) break;
    }

    // ── Selected offer card ──
    // Older sections flag the chosen card with `border-prolon_green`, which is
    // what the subscription scan above reads. dk-product-reset-horizon-v4 marks
    // it with `border-2 ... bg-white` only, so that scan finds nothing there and
    // the plan line always read "One Time Purchase". Take the label straight off
    // the offer card instead — and only when the legacy class is absent, so the
    // pages already using it keep their current wording untouched.
    //
    // Deliberately does NOT flip isSubscription: that only drives the "/mo"
    // suffix paintSticky() appends, and the Reset subscription can be monthly or
    // quarterly, so "/mo" would state a price the buy box never shows. The card
    // label ("Subscribe & Save") already says it is a subscription.
    var offerText = '';
    if (!allSelected.length) {
      for (var o = 0; o < selectedCards.length; o++) {
        var offerCard = selectedCards[o];
        if (offerCard.className.indexOf('bg-white') === -1) continue;
        if (!OFFER_WORDS.test(offerCard.textContent)) continue;
        var offerNameEl = offerCard.querySelector('.name-value');
        offerText = offerNameEl ? cleanLabel(offerNameEl) : cardTitle(offerCard).trim();
        if (offerText) break;
      }
    }

    var planText = offerText || (isSubscription ? 'Subscribe & Save' : 'One Time Purchase');

    paintSticky({
      title: GENERIC_TITLE,
      flavor: flavourText,
      plan: planText,
      price: srcPrice ? srcPrice.textContent.trim() : '',
      compare: srcCompare ? srcCompare.textContent.trim() : '',
      badge: srcBadge ? srcBadge.textContent.trim() : '',
      freq: '',
      isSub: isSubscription
    });
  }

  // ──── Pick the right strategy and run it ────
  function updateStickyInfo() {
    if (bpbRoot) {
      updateFromBpb();
      return;
    }
    if (isV24) {
      var vm = window.__dkProductVM;
      if (window.dkStickySyncEnabled === true && vm && vm.selected_options) {
        updateFromVueInstance(vm);
      } else {
        updateFromV24();
      }
      return;
    }
    paintSticky(readGenericState());
  }

  // Let the section push updates the instant state changes
  window.dkUpdateSticky = updateStickyInfo;

  // Poll as a safety net (Vue re-renders elements on option change)
  setInterval(updateStickyInfo, 800);
  setTimeout(updateStickyInfo, 1500);
  updateStickyInfo();

  // The bundle builder fires this on every quantity / frequency change, so the
  // bar repaints immediately instead of waiting out the poll.
  if (bpbRoot) {
    document.addEventListener('bpb:change', updateStickyInfo);
  }

  // Also listen for variant:change events from the picker for instant updates
  if (variantPicker) {
    variantPicker.addEventListener('variant:change', function () {
      setTimeout(updateStickyInfo, 100);
    });
  }

  // ──── Intersection Observer — show/hide sticky bar ────
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var show = false;
        if (!entry.isIntersecting) {
          var rect = entry.boundingClientRect;
          show = rect.bottom < 0;
        }
        stickyBar.style.transform = show ? 'translateY(0)' : 'translateY(100%)';
        // The bar can be hidden outright (A/B gate on bundle-builder PDPs), and
        // dk-sticky-visible pushes the accessibility launcher and chat widget up
        // by 96px. Tie it to the bar actually being rendered so control pages do
        // not open a gap for a bar that never appears.
        var rendered = getComputedStyle(stickyBar).display !== 'none';
        document.body.classList.toggle('dk-sticky-visible', show && rendered);
      });
    },
    { threshold: 0 }
  );

  observer.observe(observeTarget);
})();